<template>
  <div>
    <label class="text-uppercase text-muted font-weight-bold small">SmartTag Integration Code</label>
    <b-alert show>
      Paste the below code snippet into your page. Please note that all non-SIMPLE units must be served directly
      onto page and not inside an iframe.
    </b-alert>
    <code>
      <b-form-textarea
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        readonly
        class="squared-textarea bg-white" rows="15"
        :value="integrationCode">
      </b-form-textarea>
    </code>
  </div>
</template>

<script>
  export default {
      name: 'IntegrationSmartTag',
      props: {
          zone: { required: true, type: Object }
      },
      computed: {
          integrationCode () {
            return '<script src="//ads.smrtb.com/pbiab.js"></\script>\n' +
              '<script>\n' +
              '  smartrtb.run({ zone_id: "' + this.zone.id + '" })\n' +
              '</\script>'
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Zone/ZoneSettings/Integrations/SmartTag.vue